<template>
  <div>
    <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
         class="pt-12 pb-5">
      <slot name="title">
        <h1 v-if="title">{{ title }}</h1>
      </slot>
      <slot name="intro">
        <p v-if="intro" class="mt-6">{{ intro }}</p>
      </slot>
    </div>
    <fin-work-in-progress/>
  </div>
</template>

<script>
import FinWorkInProgress from "@/components/common/WorkInProgress"

export default {
  name: "FinWorkInProgessPage",
  components: {FinWorkInProgress},
  props: {
    title: {
      type: String
    },
    intro: {
      type: String
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
